<router-outlet></router-outlet>

<p-toast class="!fixed !top-4 !right-4 z-[12000]">
  <ng-template pTemplate="message" let-message>
    <div
      class="backdrop-blur-xl bg-white/30 border border-white/50 rounded-xl shadow-lg"
    >
      {{ message.detail }}
    </div>
  </ng-template>
</p-toast>
<p-confirmDialog></p-confirmDialog>
